module.exports = __webpack_public_path__ + "pc/img/logo.09a6e15e.png";